import React, { useState, useEffect } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import { makeStyles } from '@material-ui/core/styles';

//iconos
import { Create, Add, Receipt, Visibility, RestoreFromTrash, Apps } from '@material-ui/icons';

//tabla y card components
import Button from 'components/CustomButtons/Button.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

//servicios
import { wsGetAll } from 'services/WService.js';

//modal
import Modal from './Modal';
import { useModal } from 'hooks/useModal';
import { Toasty, useToasty } from 'hooks/Toasty';
import ButtonDelete from 'hooks/ButtonDelete';
import { WithApp } from 'contexts/appContext';
import { Link } from 'react-router-dom';
import { wsUpdate } from 'services/WService';
import RegularButton from 'components/CustomButtons/Button';
import UserAppModal from 'components/Tvendo/Setting/User/UserAppModal';
import ButtonResetPassword from 'components/Tvendo/Common/ButtonResetPassword';

const useStyles = makeStyles({
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px',
  },
});

//columnas para llenar la tabla
const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 210 },
  { Header: 'Código', accessor: 'code', width: 100 },
  { Header: 'Nombre vendedor', accessor: 'name', width: 200 },
  { Header: 'Fecha de creación', accessor: 'created_at', width: 170 },
  { Header: 'DNI', accessor: 'dni', width: 150 },
  { Header: 'Teléfono', accessor: 'phone', width: 150 },
  { Header: 'Múltiple FV', accessor: 'multiple_sale_forces', width: 120 },
  { Header: 'Tipo', accessor: 'seller_type', width: 150 },
  { Header: 'Validar gps', accessor: 'validate_gps', width: 150 },
  // { Header: 'Fabricante', accessor: 'rsales_manufacturer', width: 150 },
  // { Header: 'Modelo', accessor: 'rsales_model', width: 150 },
  // { Header: 'UUID', accessor: 'rsales_uuid', width: 150 },
  { Header: 'Estado', accessor: 'state', width: 150 },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];

export default WithApp(function Seller(props) {
  const classes = useStyles();

  const [model, setOpen] = useModal();
  const [notify, showNotify] = useToasty();
  const [sellers, setSellers] = useState([]);
  const [appModel, setAppModel] = useModal();

  const [trashed, setTrashed] = useState(false);
  const [dataLoading, setDataLoading] = useState(false);

  async function loadSellers() {
    setDataLoading(true);
    let response = await wsGetAll(`base/seller${trashed ? '?trashed=Y' : ''}`);
    setDataLoading(false);
    if (response.success) setSellers(response.data);
  }

  async function restoreSeller(seller) {
    setDataLoading(true);
    let response = await wsUpdate(`base/seller/${seller.id}/restore`);
    setDataLoading(false);
    if (response.success) {
      showNotify(response.message);
      loadSellers();
    } else {
      showNotify(response.message, 'error');
    }
  }

  useEffect(() => {
    setSellers([]);
    loadSellers();
  }, [trashed]);

  return (
    <>
      <Toasty action={notify} />
      <Modal model={model} setOpen={setOpen} showNotify={showNotify} reload={loadSellers} />
      <UserAppModal
        model={appModel}
        setOpen={setAppModel}
        showNotify={showNotify}
        canDelete={false}
        reload={loadSellers}
      />
      <Card>
        <CardHeader icon>
          <AllowedGuard
            permission={ConstantPermissions.BASE_SELLERS_STORE}
            component={
              <CardIcon color="primary">
                <Receipt style={{ color: 'white' }} />
              </CardIcon>
            }
          >
            <CardIcon
              onClick={() => setOpen({})}
              pointer="true"
              color={props.themeContext.buttonColorSuccess}
            >
              <Add />
            </CardIcon>
          </AllowedGuard>
          <h4 className={classes.cardIconTitle}>
            Listado de Vendedores {dataLoading && <LoadingSpinner />}
          </h4>

          <button onClick={() => setTrashed((trashed) => !trashed)}>
            {trashed ? 'Ver activos' : 'Ver eliminados'}
          </button>
        </CardHeader>
        <CardBody>
          <ReactTable
            excelName="Vendedores"
            // defaultWidth={1400}
            columns={columns}
            data={sellers.map((seller, i) => {
              //mapeando listado para las acciones
              return {
                num: (
                  <div className="actions-right">
                    {i + 1}
                    {seller.deleted_at === null ? (
                      <>
                        <AllowedGuard permission={ConstantPermissions.BASE_SELLERS_UPDATE}>
                          <Button
                            justIcon
                            round
                            simple
                            color={props.themeContext.buttonColorWarning}
                            onClick={() => setOpen(seller)}
                          >
                            <Create />
                          </Button>
                        </AllowedGuard>
                        <AllowedGuard permission={ConstantPermissions.BASE_SELLERS_SHOW}>
                          <Button
                            justIcon
                            round
                            simple
                            color={props.themeContext.buttonColorWarning}
                            disabled={seller.seller_type === 'O'}
                          >
                            <Link to={`${seller.id}`}>
                              <Visibility />
                            </Link>
                          </Button>
                        </AllowedGuard>
                        <AllowedGuard permission={ConstantPermissions.BASE_SELLERS_UPDATE}>
                          <RegularButton
                            justIcon
                            round
                            simple
                            color="info"
                            onClick={() => setAppModel(seller.user)}
                            disabled={seller.user === null || seller.user === undefined}
                          >
                            <Apps />
                          </RegularButton>
                        </AllowedGuard>
                        <AllowedGuard permission={ConstantPermissions.ADMIN_ACCESS_USER_CHANGE_PASSWORD}>
                          <ButtonResetPassword
                            userId={seller.user?.id}
                            nombre={seller.SlpName}
                          />
                        </AllowedGuard>
                        <AllowedGuard permission={ConstantPermissions.BASE_SELLERS_DELETED}>
                          <ButtonDelete entity="base/seller" id={seller.id} reload={loadSellers} />
                        </AllowedGuard>
                      </>
                    ) : (
                      <>
                        <AllowedGuard permission={ConstantPermissions.BASE_SELLERS_DELETED}>
                          <Button
                            justIcon
                            round
                            simple
                            onClick={() => restoreSeller(seller)}
                            color="success"
                          >
                            <RestoreFromTrash />
                          </Button>
                        </AllowedGuard>
                      </>
                    )}
                  </div>
                ),
                code: seller.SlpCode,
                name: seller.SlpName,
                created_at: seller.created_at,
                dni: seller.dni,
                phone: seller.phone,
                multiple_sale_forces: seller.multiple_sale_forces === 'Y' ? 'Si' : 'No',
                seller_type:
                  seller.seller_type === 'S' ? 'Campo' : seller.seller_type ? 'Oficina' : '-',
                validate_gps: seller.validate_gps === 'Y' ? 'Si' : 'No',
                rsales_manufacturer: seller.oauth_app_user?.rsales_manufacturer ?? '-',
                rsales_model: seller.oauth_app_user?.rsales_model ?? '-',
                rsales_uuid: seller.oauth_app_user?.rsales_uuid ?? '-',
                state: seller.state === 'A' ? 'Activo' : 'Inactivo',
                actions: '',
              };
            })}
          />
        </CardBody>
      </Card>
    </>
  );
});
